export var ConsultScene;
(function (ConsultScene) {
    ConsultScene[ConsultScene["Feed"] = 0] = "Feed";
    ConsultScene[ConsultScene["Search"] = 1] = "Search";
})(ConsultScene || (ConsultScene = {}));
/**
 * URL上的参数
 */
export var ConsultQueryName;
(function (ConsultQueryName) {
    // 来源
    ConsultQueryName["From"] = "from";
    // 搜索词
    ConsultQueryName["Query_Word"] = "query_word";
    // 关键词
    ConsultQueryName["Key_Word"] = "key_word";
    // 广告点击id
    ConsultQueryName["Click_ID"] = "click_id";
    // traceId
    ConsultQueryName["Trace_ID"] = "trace_id";
    ConsultQueryName["Trace_ID_V2"] = "traceid";
    // landingUrl
    ConsultQueryName["Landing_Url"] = "landingUrl";
    // 标识是审核/预览场景  1-审核 2-预览
    ConsultQueryName["Page_Status"] = "pagestatus";
    ConsultQueryName["Page_Id"] = "page_id";
    ConsultQueryName["App_Id"] = "app_id";
    ConsultQueryName["Snapshot_Token"] = "snapshot_token";
    ConsultQueryName["Disease"] = "disease";
})(ConsultQueryName || (ConsultQueryName = {}));
/**
 * cookie 枚举值
 */
export var ConsultCookieName;
(function (ConsultCookieName) {
    // 手机号
    ConsultCookieName["Mobile"] = "fmc_auto_phonenum";
    ConsultCookieName["Carrier_Type"] = "fmc_auto_carrierType";
    ConsultCookieName["Encrypt_Phone"] = "fmc_auto_encryptPhone";
    // 会话id
    ConsultCookieName["Guest_Id"] = "fmc_con_guest_id";
    ConsultCookieName["Guest_Id_Legacy"] = "fmc_con_guest_id_legacy";
    // 广点通id
    ConsultCookieName["GDT_UID"] = "gdt_uid";
})(ConsultCookieName || (ConsultCookieName = {}));
export var ConsultFromValues;
(function (ConsultFromValues) {
    // 全屏
    ConsultFromValues["Xj_Full"] = "xjfull";
    ConsultFromValues["xj_Half"] = "xjhalf";
})(ConsultFromValues || (ConsultFromValues = {}));
